// removed by extract-text-webpack-plugin
module.exports = {"theme":"#3f9dfe"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/element-variables.scss
// module id = +hAf
// module chunks = 43